import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import Index from "@/pages/Index";
import { lazyWithRetry } from "@/lib/lazyWithRetry";

const AboutPage = lazyWithRetry(() => import("@/pages/AboutPage"));
const ContactPage = lazyWithRetry(() => import("@/pages/ContactPage"));
const FAQPage = lazyWithRetry(() => import("@/pages/FAQPage"));
const ShippingPage = lazyWithRetry(() => import("@/pages/ShippingPage"));
const ReturnsPage = lazyWithRetry(() => import("@/pages/ReturnsPage"));
const AngraKopPage = lazyWithRetry(() => import("@/pages/AngraKopPage"));
const PrivacyPage = lazyWithRetry(() => import("@/pages/PrivacyPage"));
const TermsPage = lazyWithRetry(() => import("@/pages/TermsPage"));
const BlogPage = lazyWithRetry(() => import("@/pages/BlogPage"));
const BlogPostPage = lazyWithRetry(() => import("@/pages/BlogPostPage"));
const SustainabilityPage = lazyWithRetry(() => import("@/pages/SustainabilityPage"));
const CareersPage = lazyWithRetry(() => import("@/pages/CareersPage"));
const PurchaseTermsPage = lazyWithRetry(() => import("@/pages/PurchaseTermsPage"));
const CustomerServicePage = lazyWithRetry(() => import("@/pages/CustomerServicePage"));
const AuthPage = lazyWithRetry(() => import("@/pages/AuthPage"));
const ResetPasswordPage = lazyWithRetry(() => import("@/pages/ResetPasswordPage"));
const WishlistPage = lazyWithRetry(() => import("@/pages/WishlistPage"));
const SearchResultsPage = lazyWithRetry(() => import("@/pages/SearchResultsPage"));
const CartPage = lazyWithRetry(() => import("@/pages/CartPage"));
const CheckoutPage = lazyWithRetry(() => import("@/pages/CheckoutPage"));
const OrderConfirmationPage = lazyWithRetry(() => import("@/pages/OrderConfirmationPage"));
const NamnbrickorPage = lazyWithRetry(() => import("@/pages/NamnbrickorPage"));

const OutletPage = lazyWithRetry(() => import("@/pages/OutletPage"));
const KampanjPage = lazyWithRetry(() => import("@/pages/KampanjPage"));
const HundfoderCampaignPage = lazyWithRetry(() => import("@/pages/campaigns/HundfoderCampaignPage"));
const FuzzYardCampaignPage = lazyWithRetry(() => import("@/pages/campaigns/FuzzYardCampaignPage"));
const OutletCampaignPage = lazyWithRetry(() => import("@/pages/campaigns/OutletCampaignPage"));
const HundtillbehorCampaignPage = lazyWithRetry(() => import("@/pages/campaigns/HundtillbehorCampaignPage"));
const HundkladerCampaignPage = lazyWithRetry(() => import("@/pages/campaigns/HundkladerCampaignPage"));

const NotFound = lazyWithRetry(() => import("@/pages/NotFound"));
const SupplierPage = lazyWithRetry(() => import("@/pages/SupplierPage"));
const MyAccountPage = lazyWithRetry(() => import("@/pages/MyAccountPage"));
const ReturnRequestPage = lazyWithRetry(() => import("@/pages/ReturnRequestPage"));
const PickupPage = lazyWithRetry(() => import("@/pages/PickupPage"));
const DomainStatusPage = lazyWithRetry(() => import("@/pages/DomainStatusPage"));
const ZooiGrowthCommandCenter = lazyWithRetry(() => import("@/pages/ZooiGrowthCommandCenter"));
const PMaxAuditOS = lazyWithRetry(() => import("@/pages/PMaxAuditOS"));
const ProductFinderQuiz = lazyWithRetry(() => import("@/pages/ProductFinderQuiz"));
const ControlTowerPage = lazyWithRetry(() => import("@/pages/control-tower/ControlTowerPage"));
const TrackingStatusPage = lazyWithRetry(() => import("@/pages/TrackingStatusPage"));
const AccessDeniedPage = lazyWithRetry(() => import("@/pages/AccessDeniedPage"));
const DomainHelpPage = lazyWithRetry(() => import("@/pages/DomainHelpPage"));

export const staticRoutes = (
  <>
    <Route path="/" element={<Index />} />
    <Route path="/om-oss" element={<AboutPage />} />
    <Route path="/kontakt" element={<ContactPage />} />
    <Route path="/faq" element={<FAQPage />} />
    <Route path="/frakt-leverans" element={<ShippingPage />} />
    <Route path="/returer" element={<ReturnsPage />} />
    <Route path="/retur-byte" element={<Navigate to="/returer" replace />} />
    <Route path="/retur-begaran" element={<ReturnRequestPage />} />
    <Route path="/angra-kop" element={<AngraKopPage />} />
    <Route path="/integritetspolicy" element={<PrivacyPage />} />
    <Route path="/anvandarvillkor" element={<TermsPage />} />
    <Route path="/hallbarhet" element={<SustainabilityPage />} />
    <Route path="/jobba-hos-oss" element={<CareersPage />} />
    <Route path="/kopvillkor" element={<PurchaseTermsPage />} />
    <Route path="/kundservice" element={<CustomerServicePage />} />
    <Route path="/blogg" element={<BlogPage />} />
    <Route path="/blogg/:slug" element={<BlogPostPage />} />
    <Route path="/onskelista" element={<WishlistPage />} />
    <Route path="/logga-in" element={<AuthPage />} />
    <Route path="/registrera" element={<Navigate to="/logga-in" replace />} />
    <Route path="/medlem" element={<Navigate to="/logga-in" replace />} />
    <Route path="/mitt-konto" element={<MyAccountPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/kassa" element={<CheckoutPage />} />
    <Route path="/order-bekraftelse" element={<OrderConfirmationPage />} />
    <Route path="/sok" element={<SearchResultsPage />} />
    <Route path="/varukorg" element={<CartPage />} />
    <Route path="/kategorier" element={<Navigate to="/produkter" replace />} />
    <Route path="/kampanjer" element={<Navigate to="/kampanj" replace />} />
    <Route path="/artiklar" element={<Navigate to="/blogg" replace />} />
    <Route path="/kampanj" element={<KampanjPage />} />
    <Route path="/kampanj/hundfoder" element={<HundfoderCampaignPage />} />
    <Route path="/kampanj/fuzzyard" element={<FuzzYardCampaignPage />} />
    <Route path="/kampanj/outlet" element={<OutletCampaignPage />} />
    <Route path="/kampanj/hundtillbehor" element={<HundtillbehorCampaignPage />} />
    <Route path="/kampanj/hundklader" element={<HundkladerCampaignPage />} />
    <Route path="/kampanj/foder-godis-rea" element={<Navigate to="/kampanj/outlet" replace />} />
    <Route path="/kampanj/50-rabatt" element={<Navigate to="/kampanj/outlet" replace />} />
    <Route path="/outlet" element={<OutletPage />} />
    <Route path="/namnbrickor" element={<NamnbrickorPage />} />
    <Route path="/zooi-kattmat" element={<Navigate to="/katt/foder" replace />} />
    <Route path="/bli-leverantor" element={<SupplierPage />} />
    <Route path="/avhamtning" element={<PickupPage />} />
    <Route path="/status" element={<DomainStatusPage />} />
    <Route path="/growth-command-center" element={<ZooiGrowthCommandCenter />} />
    <Route path="/pmax-audit-os" element={<PMaxAuditOS />} />
    <Route path="/kampanj/hundfoder-premium" element={<Navigate to="/kampanj/hundfoder" replace />} />
    <Route path="/kampanj/produktsida-demo" element={<Navigate to="/produkter" replace />} />
    <Route path="/kampanj/kategori/:category" element={<Navigate to="/produkter" replace />} />
    <Route path="/kopguide" element={<ProductFinderQuiz />} />
    <Route path="/quiz" element={<ProductFinderQuiz />} />
    <Route path="/control-tower" element={<ControlTowerPage />} />
    <Route path="/tracking-status" element={<TrackingStatusPage />} />
    <Route path="/access-denied" element={<AccessDeniedPage />} />
    <Route path="/atkomst-nekad" element={<Navigate to="/access-denied" replace />} />
    <Route path="/domain-help" element={<DomainHelpPage />} />
    <Route path="/421" element={<DomainHelpPage />} />

    {/* Top-level alias redirects (defaults to hund where ambiguous) */}
    <Route path="/hundtäcken" element={<Navigate to="/hund/klader-uteliv/tacken" replace />} />
    <Route path="/hundtacken" element={<Navigate to="/hund/klader-uteliv/tacken" replace />} />
    <Route path="/matskalar" element={<Navigate to="/hund/matplats/matskallar" replace />} />
    <Route path="/matskålar" element={<Navigate to="/hund/matplats/matskallar" replace />} />
    <Route path="/dragleksaker" element={<Navigate to="/hund/leksaker/rep-dragleksaker" replace />} />
    <Route path="/hygien" element={<Navigate to="/hund/vard-halsa/hygien" replace />} />
    <Route path="/tandvard" element={<Navigate to="/hund/vard-halsa/tandvard" replace />} />

    <Route path="*" element={<NotFound />} />
  </>
);
